import { GTextAreaProps } from './types'

export const GTextArea = (props: GTextAreaProps) => {
	const {
		value,
		onChange: handleChange,
		label,
		placeholder,
		cols,
		rows,
		name,
		id,
		ariaDescribedby,
		helpText,
		error,
		className,
		ref,
		disabled
	} = props
	return (
		<div className={`${className} relative`}>
			{label && (
				<label
					htmlFor={label}
					className="text-left block text-sm font-medium text-color-text-default mb-1"
				>
					{label}
				</label>
			)}
			<div className="rounded-md">
				<textarea
					ref={ref}
					name={name}
					value={value}
					id={id}
					cols={cols}
					rows={rows}
					className={
						'bg-transparent disabled:bg-gray-100 focus:ring-0 focus:border-t-dark-blue block !font-normal text-color-text-default w-full sm:text-sm border-t-input-border rounded-md placeholder:text-sm placeholder:italic placeholder:text-gray-400'
					}
					placeholder={placeholder}
					aria-describedby={ariaDescribedby}
					onChange={(e) => handleChange(e)}
					disabled={disabled}
				/>
			</div>
			{error && <p className="mt-1 text-xs text-red-700">{error}</p>}
			{helpText && <p className="mt-2 text-sm text-t-secondary">{helpText}</p>}
		</div>
	)
}
